import { render, staticRenderFns } from "./ListHistory.vue?vue&type=template&id=7f54348d"
import script from "./ListHistory.vue?vue&type=script&lang=js"
export * from "./ListHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports